module.exports = __webpack_public_path__ + "pc/img/body_basic-9.81dcdecf.png";